import { render, staticRenderFns } from "./viewLICIT.vue?vue&type=template&id=10c664c8&scoped=true"
import script from "./viewLICIT.vue?vue&type=script&lang=js"
export * from "./viewLICIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c664c8",
  null
  
)

export default component.exports